import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection, doc } from 'firebase/firestore'

export default class FormSection extends BaseModel {
  constructor(id: string) {
    super(collection(doc(collection(db, 'forms'), id), 'sections'))
  }
}
